import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesConfigureRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-configure',
	path: '/secure/admin/ConfigureFieldScreenScheme.jspa',
};
